import indexedDbService, { IndexedDbConfig } from './indexedDb.service';

interface CustomerRecord {
  CUS_ID: string;
  FCM_TOKEN: string;
  LAST_REFRESH_DATE: number;
  CREATED_DATE: number;
}

const dbConfig: IndexedDbConfig = {
  databaseName: 'PushNotificationCache',
  version: 1,
  store: {
    name: 'OptInOutCache',
    keyPath: 'CUS_ID',
  },
};

const insertRecord = async (record: CustomerRecord): Promise<IDBValidKey> => {
  try {
    return await indexedDbService.insertRecord<CustomerRecord>(dbConfig, record);
  } catch (error) {
    console.error('Error inserting push notification record:', error);
    const errorMessage = error instanceof Error && error.message ? error.message : 'Unknown error';
    throw new Error(`Failed to insert push notification record for customer ${record.CUS_ID}: ${errorMessage}`);
  }
};

const findRecord = async (customerId: string): Promise<CustomerRecord | undefined> => {
  try {
    return await indexedDbService.findRecord<CustomerRecord>(dbConfig, customerId);
  } catch (error) {
    console.error('Error finding push notification record:', error);
    const errorMessage = error instanceof Error && error.message ? error.message : 'Unknown error';
    throw new Error(`Failed to find push notification record for customer ${customerId}: ${errorMessage}`);
  }
};

const updateRecord = async (record: CustomerRecord): Promise<IDBValidKey> => {
  try {
    return await indexedDbService.updateRecord<CustomerRecord>(dbConfig, record);
  } catch (error) {
    console.error('Error updating push notification record:', error);
    const errorMessage = error instanceof Error && error.message ? error.message : 'Unknown error';
    throw new Error(`Failed to update push notification record for customer ${record.CUS_ID}: ${errorMessage}`);
  }
};

const countRecordsByToken = async (record: CustomerRecord): Promise<number> => {
  try {
    return await indexedDbService.countRecordsByField<CustomerRecord>(
      dbConfig,
      'FCM_TOKEN',
      record.FCM_TOKEN
    );
  } catch (error) {
    console.error('Error counting records by token:', error);
    const errorMessage = error instanceof Error && error.message ? error.message : 'Unknown error';
    throw new Error(`Failed to count records with token ${record.FCM_TOKEN}: ${errorMessage}`);
  }
};

export default {
  insertRecord,
  findRecord,
  updateRecord,
  countRecordsByToken
};

// eslint-disable-next-line prettier/prettier
export type { CustomerRecord };

